import React, { useEffect, useCallback } from "react";
import { Container } from "react-bootstrap";
import ElementLoader from "../Loader/ElementLoader";
import GatewayUrl from "../Gateway/Gateway";
import ChangeAbsenceTimeCompleteModal from "./modal/ChangeAbsenceTimeCompleteModal";
import AbsenceTimeContent from "./entrys/AbsenceTimeContent";
import { RootState } from '../../store/store'
import { useSelector, useDispatch } from 'react-redux'
import { handleLoadingError, logoutUser, setSessionInvalid } from '../../store/features/session'
import {
  setAbsenceEntrys, setLoadAbsenceEntrys
} from '../../store/features/entrys'
import { setAbsenceChangeCompledetModal } from '../../store/features/absences'

import "./style/LearningAndAbsenceTimeOverview.css";

const LearningAndAbsenceTimeOverview = (): JSX.Element => {
  const dispatch = useDispatch()

  const loadingAbsentTimeApi: boolean = useSelector((state: RootState) => state.entrys.loadAbsenceEntrys)
  const changeAbsenceTimeComplete: boolean = useSelector((state: RootState) => state.absenceReasons.absenceChangeCompledetModal)
  const token: string = useSelector((state: RootState) => state.participant.token)
  const startDate: string = useSelector((state: RootState) => state.participant.startDate)
  const endDate: string = useSelector((state: RootState) => state.participant.endDate)

  // Load Abesent Times
  const LoadAbesentTimes = useCallback(async () => {
    dispatch(setLoadAbsenceEntrys(true))

    await fetch(GatewayUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        method: "getAbsentTimes",
        sessionId: token,
        from: startDate,
        to: endDate,
      }),
    })
      .then((response) => response.json())
      .then((result: any) => {
        if (result.error) {
          dispatch(setSessionInvalid(true))
          dispatch(logoutUser())
        } else {
          dispatch(setAbsenceEntrys(result.reverse()))
          dispatch(setLoadAbsenceEntrys(false))
        }
      })
      .catch(() => dispatch(handleLoadingError("lzk#getAbsentTimes")));
  }, [dispatch, endDate, startDate, token])


  useEffect(() => {
    window.scrollTo(0, 0);
    LoadAbesentTimes()
  }, [
    LoadAbesentTimes,
  ]);

  return (
    <div className="container-wbs fixing-select-index-issue pb-0">
      <Container>
        <div className="headline-container">
          <h3 className="text-center my-auto h-100"><i className="my-auto h-100 headline-icon fal fa-poll-h"></i> Ihre bisherigen Abwesenheiten {!loadingAbsentTimeApi && <i className="fal fa-sync" onClick={() => LoadAbesentTimes()} style={{ fontSize: 20, marginLeft: 15, cursor: "pointer" }}></i>}</h3>
        </div>

        <hr></hr>

        {loadingAbsentTimeApi ? <ElementLoader /> : <AbsenceTimeContent />}
      </Container>

      <ChangeAbsenceTimeCompleteModal
        show={changeAbsenceTimeComplete}
        onHide={() => dispatch(setAbsenceChangeCompledetModal(false))}
      />
    </div>
  )
}

export default LearningAndAbsenceTimeOverview;


